export type FormStepsState = {
  steps: number;
  current: number;
  percent: number;
};

export const formStepActions = ['form_step_prev', 'form_step_next', 'form_step_reset'] as const;

export type FormStepStateAction = (typeof formStepActions)[number];
